<div class="card border-0 calendar-card">
    <div class="card-header bg-white">
        <div class="d-flex justify-content-between align-items-center">
            <div>
                <h5 class="fw-bold mb-0">
                    Event Calendar
                </h5>
                <small class="text-muted">
                    {{ monthYear() }}
                </small>
            </div>
            <div class="btn-group">
                <button class="btn btn-sm btn-outline-secondary" (click)="previousMonth()">
                    <i class="bi bi-chevron-left"></i>
                </button>
                <button class="btn btn-sm btn-primary" (click)="goToday()">
                    Today
                </button>
                <button class="btn btn-sm btn-outline-secondary" (click)="nextMonth()">
                    <i class="bi bi-chevron-right"></i>
                </button>
            </div>
        </div>
    </div>

    <div class="card-body mb-0 pb-1">
        <div class="row">
            <div class="col-lg-8">
                <div class="calendar-grid">
                    <div class="day-header dview" *ngFor="let day of weekDays;">
                        {{ day }}
                    </div>
                    <div class="day-header mview" *ngFor="let day of weekDaysShort;">
                        {{ day }}
                    </div>

                    @for(day of calendarDays(); track day.date) {

                    <div class="day-cell" [class.today]="day.today" [class.other-month]="!day.currentMonth"
                        (click)="selectDay(day)">
                        <span class="date-number">
                            {{ day.date.getDate() }}
                        </span>
                        <div class="event-dots">
                            @for(event of day.events; track event.id) {
                            <span class="event-dot" [class]="eventClass(event.type)">
                            </span>
                            }
                        </div>
                    </div>
                    }
                </div>
            </div>

            <div class="col-lg-4">
                <div class="event-panel">
                    <h6 class="fw-bold mb-3">
                        Events
                    </h6>

                    @for(event of getSelectedEvents(); track event.id) {

                    <div class="event-item">
                        <div class="event-badge" [class]="eventClass(event.type)">
                        </div>
                        <div>
                            <div class="fw-semibold">
                                {{ event.title }}
                            </div>

                            <small class="text-muted">
                                {{ event.time }}
                            </small>
                        </div>
                    </div>
                    }

                    @if(getSelectedEvents().length === 0) {

                    <div class="text-center py-5 text-muted">
                        No events scheduled
                    </div>
                    }
                </div>
            </div>
        </div>
    </div>
</div>
